export default __webpack_public_path__ + "static/media/awele.4f396d35.webp";